function normalizeV3ListingTag(value: string): string {
  return value.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
}

export function hasV3ListingTag(tags: Array<string> | null | undefined, tag: string): boolean {
  const normalized = normalizeV3ListingTag(tag);
  return (tags ?? []).some((value) => normalizeV3ListingTag(value) === normalized);
}
